import React, { useState } from "react";
import {
  MainDiv,
  Container,
  LogoImage,
  LoginForm,
  Input,
  Header1,
  Header2,
  Anchor,
  Message,
  ButtonIcon,
  IconContainer,
  AnchorButton,
} from "./styles";
import { postLogin } from "../../services/user/postActions";
import { useToasts } from "react-toast-notifications";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/constants";
import HubReserveLogo from "../../assets/hub-reserve-text.png";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { InputModal } from "../../components/InputModal";
import { ContactForm } from "../../components/ContactForm";
import Spinner from "../../components/Spinner/Spinner";
import { Button, IconButton, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Login = () => {
  const { addToast } = useToasts();
  const navigate = useNavigate();

  // ------------------- STATES -------------------
  const [openInputModal, setOpenInputModal] = React.useState(false);
  const [openContactForm, setOpenContactForm] = React.useState(false);

  const [userEmail, setUserEmail] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // ------------------- LOGIN REQUEST -------------------
  const accessLogin = async (event: any) => {
    // Preventing that the form sends the information
    event.preventDefault();

    // ------------------- EMAIL VALIDATION -------------------
    const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail);
    if (!emailValidation) {
      addToast("El email no es válido", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    setLoadingLogin(true);
    await postLogin(userEmail, userPwd)
      .then((res) => {
        if (res.status !== 200) {
          addToast("Credenciales inválidas", {
            appearance: "error",
            autoDismiss: true,
          });
        } else {
          addToast("Bienvenido", {
            appearance: "success",
            autoDismiss: true,
          });

          // ------------------- LOCAL STORAGE -------------------
          localStorage.setItem("user_type", res.data.user_type);
          localStorage.setItem("jwt", res.data.jwt);
          localStorage.setItem("user_id", res.data.id);
          (res.data.user_type === 1) ? localStorage.setItem("view", "admin") : localStorage.setItem("view", "user");

          if (res.data.user_type === 1) {
            navigate(`${ROUTES.ADMIN}${ROUTES.PANEL}`);
          } else {
            navigate(`${ROUTES.RESERVE}`);
          }
        }
        setLoadingLogin(false);
      })
      .catch((err) => {
        setLoadingLogin(false);
        addToast("Ocurrió un error, favor de verificar credenciales", {
          appearance: "error",
          autoDismiss: true,
        });
      });
  };

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => { }, [loadingLogin]);

  // ------------------- PASSWORD HANDLER -------------------
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      {openInputModal && (
        <InputModal
          title="¿Olvidaste tu contraseña?"
          description="Introduce tu dirección de correo electrónico y recibirás un enlace para restablecer la contraseña."
          action="RecoverPassword"
          buttonMessage="Enviar"
          onClose={() => setOpenInputModal(false)}
        />
      )}

      {openContactForm && (
        <ContactForm onClose={() => setOpenContactForm(false)} />
      )}

      {loadingLogin ? (
        <Spinner />
      ) : (
        <MainDiv>
          <Container>
            <LogoImage src={HubReserveLogo} alt="Hub Reserve Logo" />

            <Header1>Iniciar sesión</Header1>
            <Header2>Bienvenido a Hub Reserve</Header2>

            <LoginForm onSubmit={accessLogin}>
              {/* <Input
                type="email"
                name="email"
                placeholder="Correo electrónico"
                required
                value={userEmail}
                onChange={(event) => setUserEmail(event.target.value)}
              /> */}
              <TextField
                label="Correo electrónico"
                value={userEmail}
                variant="outlined"
                fullWidth
                required
                onChange={(event) => setUserEmail(event.target.value)}
                sx={{ margin: "15px 0" }}
                InputProps={{
                  style: {
                    borderRadius: "14px",
                  },
                }}
              />

              {/* <IconContainer>
                <ButtonIcon type="button" onClick={toggleShowPassword}>
                  {!showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </ButtonIcon>
                <Input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Contraseña"
                  required
                  value={userPwd}
                  onChange={(event) => setUserPwd(event.target.value)}
                />
              </IconContainer> */}

              <TextField
                label="Contraseña"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                value={userPwd}
                onChange={(event) => setUserPwd(event.target.value)}
                fullWidth
                required
                sx={{ margin: "5px 0 10px 0" }}
                InputProps={{
                  style: {
                    borderRadius: "14px",
                  },
                  endAdornment: (
                    <IconButton
                      onClick={toggleShowPassword}
                      sx={{
                        minWidth: 0,
                        borderRadius: "30px",
                        background: "transparent",
                      }}
                    >
                      {showPassword ? (
                        <Visibility style={{ color: "A9A9A9" }} />
                      ) : (
                        <VisibilityOff style={{ color: "A9A9A9" }} />
                      )}
                    </IconButton>
                  ),
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    accessLogin(event);
                  }
                }}
              />

              {/* <Button type="submit">Ingresar</Button> */}
              <Button
                variant="contained"
                onClick={accessLogin}
                sx={{
                  borderRadius: "12px",
                  fontSize: "18px",
                  backgroundColor: "#13314D",
                  padding: "10px 10%",
                  color: "#FFF",
                  textTransform: "none",
                  marginTop: "20px",
                  "&:hover": {
                    backgroundColor: "#111E2F",
                  },
                }}
              >
                Ingresar
              </Button>
            </LoginForm>

            <AnchorButton
              onClick={() => {
                setOpenInputModal(true);
              }}
            >
              ¿Olvidaste tu contraseña?
            </AnchorButton>
            <Message>
              ¿No tienes cuenta?{" "}
              <Anchor href={ROUTES.REGISTER}>Regístrate</Anchor>
            </Message>
            <Message>
              O bien,
              <AnchorButton
              // onClick={() => {setOpenContactForm(true);}}
              >
                <Anchor href={ROUTES.CONTACT} target="_blank" rel="noopener noreferrer">Contáctanos</Anchor>
              </AnchorButton>
            </Message>
          </Container>
        </MainDiv>
      )}
    </>
  );
};

export default Login;
